module.exports = __webpack_public_path__ + "img/img_register.9109100b.png";